import FormDrawer from 'components/__new/common/form-drawer'
import { ReactComponent as IconTimes } from "assets/images/icons/project-icons/times.svg"
import CurrencyFormat from 'utils/currencyFormat'


export const TransactionSummary = ({ isOpen, setIsOpen, transferPayload, onProceed, closeTransferSummaryModal }) => {

    // const closeTransferSummaryModal = () => {
    //     setIsOpen(false);
    // }

    return (
        <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={() => {}}>
            <div className='p-7'>

                <div className='pb-2 mb-4'>
                    <div className="flex items-center justify-between">
                        <div className="text-2xl font-bold">
                            Summary
                        </div>

                        <div onClick={closeTransferSummaryModal} className='w-7 h-7 bg-[#f4f4f4] cursor-pointer rounded-md flex items-center justify-center'>
                            <IconTimes width={30} />
                        </div>
                    </div>
                </div>
                
                <div className='border-b pb-4'>
                    <div className='flex justify-center items-center flex-col mb-4'>
                        <div className='bg-[#F3F3F3] rounded-lg py-0.5 px-2 text-[#667085] text-[14px] font-medium'>Amount</div>
                        <div className='mt-4 font-bold text-2xl'>{CurrencyFormat(transferPayload?.amount, true)}</div>
                    </div>
                    <div className='bg-[#00535C14] bg-opacity-80 rounded-2xl p-4'>
                        <div>
                            <div className='border-b pb-4 text-[#1A202C] font-medium text-lg'>Transaction Details</div>
                            <div className='flex justify-between items-center py-3'>
                                <div className='text-[#718096]'>Recipient Name</div>
                                <div className='font-medium text-[#374151]'>{transferPayload?.accountName}</div>
                            </div>
                            <div className='flex justify-between items-center py-3'>
                                <div className='text-[#718096]'>Bank Name</div>
                                <div className='font-medium text-[#374151]'>{transferPayload?.bankName}</div>
                            </div>
                            <div className='flex justify-between items-center py-3'>
                                <div className='text-[#718096]'>Account Number</div>
                                <div className='font-medium text-[#374151]'>{transferPayload?.accountNumber}</div>
                            </div>
                            <div className='flex justify-between items-center py-3'>
                                <div className='text-[#718096]'>Narration</div>
                                <div className='font-medium text-[#374151] capitalize'>{transferPayload?.narration || transferPayload?.description}</div>
                            </div>
                            {transferPayload?.transferDestination === "bank" && (
                                    <div className='flex justify-between items-center py-3'>
                                        <div className='text-[#718096]'>Fees</div>
                                        <div className='font-medium text-[#374151]'>{CurrencyFormat(transferPayload?.fees || 0, true)}</div>
                                    </div>
                                )
                            }

                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-end pt-4">
                    <button type="button" onClick={closeTransferSummaryModal} className="btn btn-transparent-primary mr-3">
                        Back
                    </button>
                    <button type="button" onClick={onProceed} className="btn btn-ep-primary">
                        Continue
                    </button>
                </div>
            </div>
        </FormDrawer>
    )
}